
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
// components
import Iconify from 'src/components/iconify';
// types
import { CaySam, CaySamNhatKy } from 'src/types/caysam';
import { OptionModel } from 'src/types/api-response';

// ----------------------------------------------------------------------

type Props = {
  gardenName: string;
  lotName: string;
  positionLabel: string;
  caySamData: CaySam | null;
  latestNhatKy: CaySamNhatKy | null;
  loaiTuoiOptions: OptionModel[];
  tinhTrangOptions: OptionModel[];
  diemSucKhoeOptions: OptionModel[];
};

export default function CaySamInfo({
  gardenName,
  lotName,
  positionLabel,
  caySamData,
  latestNhatKy,
  loaiTuoiOptions,
  tinhTrangOptions,
  diemSucKhoeOptions,
}: Props) {
  return (
    <>
      <Stack spacing={3}>
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
            Thông tin vị trí
          </Typography>
          <Stack direction="row" spacing={2}>
            <TextField
              fullWidth
              label="Vườn trồng"
              value={gardenName}
              disabled
              size="small"
              InputProps={{
                startAdornment: <Iconify icon="solar:leaf-bold" sx={{ mr: 1 }} />,
              }}
            />
            <TextField
              fullWidth
              label="Lô sâm"
              value={lotName}
              disabled
              size="small"
              InputProps={{
                startAdornment: <Iconify icon="solar:home-bold" sx={{ mr: 1 }} />,
              }}
            />
            <TextField
              fullWidth
              label="Vị trí"
              value={positionLabel}
              disabled
              size="small"
              InputProps={{
                startAdornment: <Iconify icon="solar:map-point-bold" sx={{ mr: 1 }} />,
              }}
            />
          </Stack>
        </Box>

        <Divider />

        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
            Thông tin cây sâm
          </Typography>
          <Stack spacing={2}>
            <TextField
              fullWidth
              label="Mã cây sâm"
              value={caySamData?.maCaySam || ''}
              required
              size="small"
              disabled
              helperText="Mã cây sâm hiện tại (không thể thay đổi)"
              InputProps={{
                startAdornment: (
                  <Iconify icon="solar:medal-ribbons-star-bold" sx={{ mr: 1 }} />
                ),
              }}
            />

            <FormControl fullWidth size="small" disabled>
              <InputLabel>Tuổi cây</InputLabel>
              <Select
                value={caySamData?.tuoiCay_ID ?? ''}
                label="Tuổi cây"
                startAdornment={<Iconify icon="solar:calendar-bold" sx={{ mr: 1 }} />}
              >
                {loaiTuoiOptions.map((opt) => (
                  <MenuItem key={opt.value} value={Number(opt.value)}>
                    {opt.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <Stack spacing={2}>
          <FormControl fullWidth size="small" disabled>
            <InputLabel>Tình trạng</InputLabel>
            <Select
              value={latestNhatKy?.tinhTrang ?? ''}
              label="Tình trạng"
              startAdornment={<Iconify icon="solar:flag-2-bold" sx={{ mr: 1 }} />}
            >
              {tinhTrangOptions.map((opt) => (
                <MenuItem key={opt.value} value={Number(opt.value)}>
                  {opt.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" disabled>
            <InputLabel>Điểm sức khỏe</InputLabel>
            <Select
              value={latestNhatKy?.diemSucKhoe ?? ''}
              label="Điểm sức khỏe"
              startAdornment={<Iconify icon="solar:check-circle-bold" sx={{ mr: 1 }} />}
            >
              {diemSucKhoeOptions?.map((opt) => (
                <MenuItem key={opt.value} value={Number(opt.value)}>
                  {opt.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Số lá"
            value={latestNhatKy?.soLa ?? ''}
            disabled
            size="small"
            InputProps={{
              startAdornment: <Iconify icon="solar:leaf-bold" sx={{ mr: 1 }} />,
            }}
          />
          <TextField
            fullWidth
            label="Trọng lượng"
            value={latestNhatKy?.trongLuong ?? ''}
            disabled
            size="small"
            InputProps={{
              startAdornment: <Iconify icon="solar:leaf-bold" sx={{ mr: 1 }} />,
            }}
          />
        </Stack>
      </Stack>
      <Divider sx={{ my: 3 }} />
    </>
  );
}
